import { render, staticRenderFns } from "./RewardsGreetingNoTicket.vue?vue&type=template&id=040689c1&scoped=true"
import script from "./RewardsGreetingNoTicket.vue?vue&type=script&lang=js"
export * from "./RewardsGreetingNoTicket.vue?vue&type=script&lang=js"
import style0 from "./RewardsGreetingNoTicket.vue?vue&type=style&index=0&id=040689c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040689c1",
  null
  
)

export default component.exports